export default __webpack_public_path__ + "static/media/right-arrow.ad7edd74.svg";